<template>
    <div>
        <div v-if="fetching">
            <i class="fa fa-refresh fa-spin"></i> Fetching
        </div>
        <template v-if="recommendations.length">
            <p class="h3">People often buy these things together</p>
            <hr>
            <div class="row" v-for="(row, key) in recommendations" :key="key">
                <div class="col-md-4" v-for="item in row" :key="item.id">
                    <search-result-card
                        :stock="item.product.first_variant.inventory"
                        :name="item.product.name"
                        :url="url(item.product)"
                        :min-price="item.product.min_price"
                        :min-price-tax="item.product.min_price_tax"
                        :max-price-tax="item.product.max_price_tax"
                        :max-price="item.product.max_price_tax"
                        :variant="item.product.first_variant"
                        v-cloak
                    >
                        <div slot="thumbnail">
                            <img :src="thumbnail(item.product)" :alt="item.product.name">
                        </div>
                        <span slot="title">{{ item.product.name }}</span>
                        <strong slot="sku">{{ item.product.first_variant.sku }}</strong>
                        <article slot="description">
                            <template v-html="item.product.short_description"></template>
                        </article>
                    </search-result-card>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
    import Product from '../../Services/Product.js';
    import SearchResultCard from '../Search/SearchResultCard.vue';
    import Utils from '../../Mixins/Utils';

    export default {
        components: {
            SearchResultCard,
        },
        mixins: [Utils],
        props: {
            basketId: {
                type: String,
            }
        },
        data() {
            return {
                fetching: true,
                recommendations: [],
            }
        },
        mounted() {
            this.fetch();
        },
        methods: {
            url(product) {
                return '/products/' + product.routes[0].slug;
            },
            fetch() {
                this.fetching = true;

                Product.getRecommended(this.basketId).then(response => {
                    this.recommendations = _.chunk(response, 3);
                    this.fetching = false;
                });

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Product/RecommendedProducts.vue